import { Feature } from "geojson";
import * as L from "leaflet";
import { useEffect, useState } from "react";

import { removeAllDrawnLayers } from "src/utils/map.utils";

export function useDrawPolygon(map: L.Map, options: { color?: string; fillColor?: string; fillOpacity?: number } = {}) {
  const [polygon, setPolygon] = useState<Feature | null>(null);
  const { color = "#3388ff", fillColor = "#3388ff", fillOpacity = 0.2 } = options;

  useEffect(() => {
    return function cleanup() {
      stopEditDrawing();
      removeAllDrawings();
    };
  }, []);

  function renderInitialPolygon(initialPolygon: Feature) {
    L.geoJSON(initialPolygon, {
      style: {
        color,
        fillColor,
        fillOpacity,
      },
      pane: "drawing-pane",
    })
      .addTo(map)
      .on("pm:edit", (event) => {
        // @ts-ignore: incomplete type
        setPolygon(event.layer.toGeoJSON());
      });
    setPolygon(initialPolygon);
  }

  function stopDrawing() {
    map.pm.disableDraw("Polygon");
  }

  function startDrawing() {
    // @ts-ignore: incomplete type
    map.pm.setGlobalOptions({
      panes: {
        vertexPane: "drawing-pane-vertex",
        layerPane: "drawing-pane",
        markerPane: "drawing-pane",
      },
    });
    map.pm.enableDraw("Polygon", {
      finishOn: "dblclick",
      pathOptions: {
        color,
        fillColor,
        fillOpacity,
        pane: "drawing-pane",
      },
      templineStyle: {
        pane: "drawing-pane-vertex",
        color,
      },
      hintlineStyle: {
        pane: "drawing-pane-vertex",
        color,
        dashArray: [5, 5],
      },
    });

    map.on("pm:create", (event) => {
      const { layer } = event;

      // @ts-ignore: incomplete type
      setPolygon(layer.toGeoJSON());
      map.pm.disableDraw("Polygon");
      layer.on("pm:edit", (event: L.LeafletEvent) => {
        const { layer } = event;
        setPolygon(layer.toGeoJSON());
      });
    });

    return function cleanup() {
      map.off("pm:create");
    };
  }

  function redrawDrawing() {
    setPolygon(null);
    removeAllDrawings();

    setTimeout(() => {
      startDrawing();
    }, 100);
  }

  function editDrawing() {
    // @ts-ignore: incomplete type
    map.pm.setGlobalOptions({
      limitMarkersToCount: 100,
      panes: {
        vertexPane: "drawing-pane-vertex",
        layerPane: "drawing-pane",
        markerPane: "drawing-pane",
      },
    });
    map.pm.enableGlobalEditMode({});
  }

  function stopEditDrawing() {
    map.pm.disableGlobalEditMode();
  }

  function removeAllDrawings() {
    removeAllDrawnLayers(map);
  }

  return {
    polygon,
    renderInitialPolygon,
    setPolygon,
    startDrawing,
    stopDrawing,
    editDrawing,
    redrawDrawing,
    stopEditDrawing,
    removeAllDrawings,
  };
}
